
import React, { useState } from 'react';
import { Input, Button, Row, Col, Modal, message, Spin } from 'antd';
import { getProductsCnName, changeProductsName } from '../services/productService';
import { PRODUCT_NAME_OPERATION } from '../common/constants';
const { TextArea } = Input;
const { confirm } = Modal;

function CNName() {
    const [productId, setProductId] = useState([]);
    const [productName, setProductName] = useState([]);
    const [keyword, setKeyword] = useState('');
    const [loading, setLoading] = useState(false);
    const productAvaible = productId && productId?.length;

    function handleProductIdChange(e) {
        setProductId(e.target.value.split('\n').filter(e => !!e).slice(0, 1000));
    }

    function handleKeywordChange(e) {
        setKeyword(e.target.value)
    }

    function getName() {
        setLoading(true);
        setProductName([]);
        getProductsCnName({
            productIds: productId
        }).then((res) => {
            setProductName(res.data);
            setLoading(false);
        }).catch((res) => {
            setLoading(false);
            Modal.error({
                title: '查询失败',
                content: res?.response?.data?.errors[0],
            });
        })
    }

    function handleNameChange(type) {
        if(type === PRODUCT_NAME_OPERATION.EMPTY) {
            confirm({
                title: '请确认是否清空所有标题？',
                okText: '确认',
                cancelText: '取消',
                onOk() {
                    changeName(type);
                }
            })
        } else {
            changeName(type);
        }
    }

    function changeName(type) {
        setLoading(true);
        setProductName([]);
        changeProductsName({
            productIds: productId,
            title: keyword,
            operationType: type
        }).then((res) => {
            setLoading(false);
            const { status, failPIds } = res?.data || {};
            if(status === 'fail') {
                Modal.error({
                    title: '下列商品修改失败',
                    content: (JSON.parse(failPIds) || []).join('，'),
                });
            } else {
                message.success('修改成功');
            }
        }).catch((res) => {
            setLoading(false);
            message.error('请求失败');
        })
    }

    return (
        <div>
            <Spin spinning={loading} size="large">
                <Row style={{ marginBottom: 10 }}>请输入商品ID（限1000条，超出部分取前1000条处理）</Row>
                <Row type="flex" justify="space-between" align="middle" style={{ marginBottom: 50 }}>
                    <Col span={10}>
                        <TextArea allowClear rows={10} onChange={handleProductIdChange} />
                    </Col>
                    <Col span={2}>
                        <Button disabled={!productAvaible} type="primary" block onClick={getName}>查询</Button>
                    </Col>
                    <Col span={10}>
                        <TextArea rows={10} value={productName.join('\n')} />
                    </Col>
                </Row>
                <Row type="flex" justify="start" align="middle" style={{ marginBottom: 50 }}>
                    <Col span={2}><div>标题信息</div></Col>
                    <Col span={22}><Input style={{ width: 200 }} allowClear onChange={handleKeywordChange} /></Col>
                </Row>
                <Row>
                    <Col span={6}>
                        <Button
                            type="primary"
                            disabled={!keyword || !productAvaible}
                            style={{ width: 150 }}
                            onClick={() => handleNameChange(PRODUCT_NAME_OPERATION.COVER)}
                        >覆盖</Button>
                    </Col>
                    <Col span={6}>
                        <Button
                            type="primary"
                            disabled={!keyword || !productAvaible}
                            style={{ width: 150 }}
                            onClick={() => handleNameChange(PRODUCT_NAME_OPERATION.APPEND)}
                        >追加</Button>
                    </Col>
                    <Col span={6}>
                        <Button
                            type="primary"
                            disabled={!keyword || !productAvaible}
                            style={{ width: 150 }}
                            onClick={() => handleNameChange(PRODUCT_NAME_OPERATION.DELETE)}
                        >删除</Button>
                    </Col>
                    <Col span={6}>
                        <Button
                            disabled={!productAvaible}
                            type="danger"
                            style={{ width: 150 }}
                            onClick={() => handleNameChange(PRODUCT_NAME_OPERATION.EMPTY)}
                        >清空</Button>
                    </Col>
                </Row>
            </Spin>
        </div>
    )
}

export default CNName;
